<template lang="pug">
div
  h3.page-title {{$route.meta.title}}
  component(:is="formContainer.component ? formContainer.component : 'el-card'" v-loading="isLoading")
    div.card-head(slot="header")
      el-button(type="primary" @click="Submit") 保 存
      el-button(@click="$router.go(-1)") 取 消
    div.card-body
      component.form(v-for="(form,index) of forms" :is="form.wrapComponent? form.wrapComponent : 'el-card'" v-bind="form.wrapAttrs" :key="index")
        template(#header v-if="form.name")
          | {{form.name}}
        common-form(
          ref="form"
          v-bind="form.attrs"
          :options="form.formInfo"
          :values="value"
          )
</template>

<script>


export default {
  name: 'Form',
  data() {
    return {
      isLoading: false,
      formContainer: {},
      forms: [
        {
          wrapComponent: 'el-row',
          wrapAttrs: {
            gutter: 10
          },
          attrs: {
            labelWidth: '120px',
            labelPosition: 'top',
          },
          formInfo: [
            {
              name: '产品名称(中文)',
              component: 'el-input',
              key: 'chinese_name',
              default: '',
              span: 12,
              attrs: {
                placeholder: '请输入产品名称',
              },
              rules: [
                { required: true, message: '请输入产品名称', trigger: 'blur' }
              ]
            },
            {
              name: '产品名称(外文)',
              component: 'el-input',
              key: 'foreign_name',
              default: '',
              span: 12,
              attrs: {
                placeholder: '请输入产品名称(外文)',
              },
              rules: [
                { required: true, message: '请输入产品名称(外文)', trigger: 'blur' }
              ]
            }
          ]
        },
        {
          wrapComponent: 'el-row',
          wrapAttrs: {
            gutter: 10
          },
          attrs: {
            labelWidth: '120px',
            labelPosition: 'top'
          },
          formInfo: [
            {
                name: '采购名称',
                component: 'el-input',
                key: 'purchase_name',
                default: '',
                span: 12,
                attrs: {
                  placeholder: '请输入采购名称',
                },
                rules: [
                  { required: true, message: '请输入采购名称', trigger: 'blur' }
                ]
            },
            {
              name: '采购链接',
              component: 'el-input',
              key: 'purchase_url',
              default: '',
              span: 12,
              attrs: {
                placeholder: '请输入采购链接',
              },
              rules: [
                { required: true, message: '请输入采购链接', trigger: 'blur' }
              ]
            },
          ]
        },
        {
          wrapComponent: 'el-row',
          wrapAttrs: {
            gutter: 10
          },
          attrs: {
            labelWidth: '120px',
            labelPosition: 'top',
          },
          formInfo: [
            {
              name: '采购建议价',
              component: 'el-input',
              key: 'purchase_price',
              default: '',
              span: 6,
              attrs: {
                placeholder: '请输入采购建议价',
              },
              rules: [
                { required: true, message: '请输入采购建议价', trigger: 'blur' }
              ]
            },
            {
              name: '重(kg)',
              component: 'el-input',
              key: 'heavy',
              default: 0,
              span: 6,
              attrs: {
                placeholder: '请输入重(kg)',
              },
              rules: [
                { required: true, message: '请输入重(kg)', trigger: 'blur' }
              ]
            },
            {
              name: '体积',
              component: 'el-input',
              key: 'volume',
              default: 0,
              span: 6,
              attrs: {
                placeholder: '请输入体积',
              },
              rules: [
                { required: true, message: '请输入体积', trigger: 'blur' }
              ]
            },
            {
              name: '商品分类',
              component: 'el-input',
              key: 'type',
              default: '',
              span: 6,
              attrs: {
                placeholder: '请输入分类',
              },
              rules: [
                { required: true, message: '请输入分类', trigger: 'blur' }
              ]
            }
          ]
        },
        {
          wrapComponent: 'el-row',
          attrs: {
            labelPosition: 'top'
          },
          formInfo: [
            {
              name: '账户名',
              component: 'el-input',
              key: 'username',
              default: (this.userInfo || {}).username,
              span: 6,
              attrs: {
                disabled: true
              }
            },
          ]
        },
        {
          wrapComponent: 'div',
          attrs: {
            inline: true,
            labelWidth: '120px',
            labelPosition: 'top'
          },
          formInfo: [
            {
              name: '缩略图',
              component: 'Uploader',
              key: 'image',
              default: ''
            },
          ]
        },
        {
          wrapComponent: 'div',
          attrs: {
            labelWidth: '120px',
            labelPosition: 'top'
          },
          formInfo: [
            {
                name: '属性',
                component: 'Sku',
                key: 'sku',
                default: '',
                // attrs: {
                //   placeholder: '请输入sku',
                // },
                // rules: [
                //   { required: true, message: '请输入sku', trigger: 'blur' }
                // ]
            },
          ]
        },
      ],
      submit: null,
      getData: null
    }
  },
  computed: {
    value() {
      return this.$store.state.pageValue
    },
    viewType() {
      return this.$store.state.viewType
    },
    userInfo() {
      return this.$store.state.userInfo
    }
  },
  watch: {
    $route() {
      this.init()
    }
  },
  methods: {
    async Submit() {
      let formHasError = false
      let result = {}
      if (Array.isArray(this.$refs.form)) {
        result = this.$refs.form.reduce((finalForm, formData) => {
          let {hasError, form} = formData.getFormData()
          if (hasError) formHasError = hasError
          finalForm = Object.assign(finalForm, form)
          return finalForm
        }, {})
      } else {
        let {hasError, form} = this.$refs.form.getFormData()
        formHasError = hasError
        result = form
      }

      if (this.submit) {
        await this.submit({hasError: formHasError, form: result})
      }
    },
    bindDialogSubmit(Submit) {
      this.submit = Submit
    },
    bindGetData(getData) {
      this.getData = getData
    },
    async GetData() {
      this.isLoading = true
      if (this.getData) {
        let {id} = this.$route.query
        let res = {}
        if (id) {
          res = await this.getData(id)
        } else {
          res.username = this.userInfo.username
        }
        this.$store.commit('setDialogValue', res)
      }
      this.isLoading = false

    },
    init() {
      this.$store.commit('setViewType', this.$route.meta.viewType)
      this.submit = null
      this.getData = null

      const { getData, Submit } = this.$route.meta.formConfig || {}
      this.bindDialogSubmit(Submit)
      this.bindGetData(getData)
      this.GetData()
    }
  },
  mounted  () {
    this.init()
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/style/index.less';
.form {
  margin-bottom: 10px;
}

// .footer {
//   display: inline-block;
//   margin-top: 20px;
// }

// .card-body {
//   overflow-y:auto;
//   overflow-x: hidden;
//   max-height: calc(100vh - 300px);
  
// }
/deep/ .el-card__body {
  padding:0px 0px 0px 20px !important;
}
</style>